import { useLocation } from "react-router-dom";
import { useConsolidated } from "../../hooks/useConsolidated";

const CONSOLIDATED_PATHS = new Set([
  "/",
  "/cashflow",
  "/forecast",
  "/receivables",
]);

export const ConsolidatedToggle = () => {
  const location = useLocation();
  const { allowConsolidated, isConsolidated, setIsConsolidated } =
    useConsolidated();

  if (!allowConsolidated || !CONSOLIDATED_PATHS.has(location.pathname)) {
    return null;
  }

  return (
    <label className="inline-flex items-center gap-2 text-sm text-gray-600">
      <span className="hidden sm:inline">Consolidated</span>
      <button
        type="button"
        role="switch"
        aria-checked={isConsolidated}
        onClick={() => setIsConsolidated(!isConsolidated)}
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
          isConsolidated ? "bg-blue-600" : "bg-gray-300"
        }`}
        aria-label="Toggle consolidated mode"
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            isConsolidated ? "translate-x-4" : "translate-x-0.5"
          }`}
        />
      </button>
    </label>
  );
};
